<template>
  <div>
    <van-row>
      <van-col :span="20">
        <base-input v-model="queryCondition.customer_name" label="收款客户名称" />
      </van-col>
      <van-col :span="4" style="padding-top: 5px;">
        <base-button type="primary" @click="query">刷新</base-button>
      </van-col>
    </van-row>
    <van-row>
      <van-col span="24" class="tip-msg">
        提示：点击记录，可查看转账信息及修改记录状态！
      </van-col>
    </van-row>
    <van-row class="list-title">
      <van-col span="6">收款客户名称</van-col>
      <van-col span="4">转账金额</van-col>
      <van-col span="4">状态</van-col>
      <van-col span="6">创建时间</van-col>
    </van-row>
    <template v-if="data && data.length > 0">
      <van-pull-refresh v-model="loading" success-text="刷新成功" @refresh="query">
        <van-cell v-for="item in data" :key="item.id" class="list-tip"
                  @click="handleClick(item)">
          <van-col span="6" style="text-align: center;">{{ item.customer_name }}</van-col>
          <van-col span="4" style="text-align: center;">{{ item.amount }}</van-col>
          <van-col span="4" style="text-align: center;">{{ item.status_name }}</van-col>
          <van-col span="6" style="text-align: center;">{{ item.create_time }}</van-col>
        </van-cell>
      </van-pull-refresh>
      <van-tabbar safe-area-inset-bottom>
        <van-pagination v-model="queryCondition.page" :total-items="queryCondition.total" :show-page-size="4" force-ellipses @change="query()" />
      </van-tabbar>
    </template>
    <template v-else>
      <van-col span="24" class="list-tip">{{ tip }}</van-col>
    </template>
  </div>
</template>

<script>
import { getTransferList } from '@/api/transfer'
export default {
  name: 'TransferManage',
  data() {
    return {
      loading: false,
      data: [],
      tip: this.CONST.EMPTY_MSG,

      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.ROWS,
        sort: 'id',
        order: 'desc',

        customer_name: ''
      }
    }
  },
  mounted() {
    this.query();
  },
  methods: {
    query() {
      this.tip = '查询中...'
      this.loading = true
      getTransferList(this.queryCondition).then(resp => {
        this.data = resp.rows || [];
        this.data.forEach(row => {
          row.status_name = this.CONST.TRANSFER_STATUS.find(item => item.id === row.status).name;
          row.create_time = row.create_time.substring(0, 10);
        })
        this.queryCondition.total = resp.total || 0;
        if (this.data.length === 0) {
          this.tip = this.CONST.EMPTY_MSG
        }
        this.loading = false;
      }).catch(() => {
        this.tip = this.CONST.EMPTY_MSG;
      })
    },
    modifyStatus(value) {
      console.log(value)
    },
    handleClick(transfer) {
      this.$store.dispatch('app/setSelectedTransfer', transfer)
      this.$router.push('/transfer/transfer-edit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transfer/manage.vue